import React from 'react';
import ReactTypingEffect from 'react-typing-effect';
import web from '../assets/images/web.jpg'

const Home = () => {
    return (
        <div>
            <div class="hero min-h-screen" style={{backgroundImage: `url(${web})`}}>
                <div class="hero-overlay bg-opacity-60"></div>
                <div class="hero-content text-center text-neutral-content">
                    <div class="max-w-md">
                       <h1 style={{marginTop:'-150px'}} className='text-6xl text-center font-mono uppercase'><span className='font-extrabold'>Jahid</span> Hossen</h1>
                       <h3 className='text-3xl text-orange-400 font-serif font-bold'>I am a <ReactTypingEffect speed={100} eraseSpeed={0} eraseDelay={1000} typingDelay={500} text={['React Developer','Front End Developer', 'Full Stack Developer']}></ReactTypingEffect></h3>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Home;